import { ensureClientIsCurrent } from './versionBootstrap';

ensureClientIsCurrent().then((proceed) => {
  if (!proceed) {
    return;
  }
  import('./renderApp');
});
